import NumberFormat from "react-number-format";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import Typography from "../../../typography/Typography/Typography";
import {
	StyledInputProps,
	StyledInputWrapperProps,
} from "./ProxyBidNumberField.types";

const DEFAULT_FONT_SIZE = "18px";
const INCREASED_FONT_SIZE = "24px";

export const StyledInputWrapper = styled(Typography)<StyledInputWrapperProps>`
	width: 100%;
	height: 48px;
	margin: 0;
	font-weight: ${({ theme }) => theme.fontWeights.values.heaviest};
	font-size: ${DEFAULT_FONT_SIZE};
	line-height: 24px;
	position: relative;
	color: ${({ error, theme }) =>
		error
			? theme.palette.hexFor("semantic_error_700")
			: theme.palette.hexFor("fg_dark_2")};
	&.bounce {
		animation: bounce 200ms ease-in-out;
	}

	@keyframes bounce {
		0% {
			font-size: ${DEFAULT_FONT_SIZE};
		}
		50% {
			font-size: ${INCREASED_FONT_SIZE};
		}
		100% {
			font-size: ${DEFAULT_FONT_SIZE};
		}
	}
	:first-letter {
		color: ${({ theme }) => theme.palette.hexFor("neutral_400")};
	}
`;

export const StyledInput = styled(
	({ isMobileDevice, ...props }: StyledInputProps) => (
		<NumberFormat {...props} />
	)
)`
	box-sizing: border-box;
	color: inherit;
	font-weight: inherit;
	font-size: inherit;
	width: 100%;
	height: 100%;
	border: none;
	border-radius: ${({ theme }) => {
		const radiusSize = theme.radii.lg;
		return `${radiusSize} 0px 0px ${radiusSize};`;
	}};
	padding: ${({ theme }) => `${theme.space.sm} ${theme.space.xxl}`};
	text-align: center;
	border: 1px solid ${({ theme }) => `${theme.palette.hexFor("primary_1_200")}`};
	outline: none;
	display: block;
	${({ isMobileDevice, theme }) => {
		return isMobileDevice
			? `	border-radius: ${theme.radii.lg};`
			: "border-right: none;";
	}}
`;

export const StyledBidButton = styled.button<PositionProps>`
	position: absolute;
	border: none;
	margin: 0;
	padding: 0;
	height: 100%;
	width: 32px;
	background: transparent;
	display: flex;
	align-items: center;
	&:not(:disabled) {
		cursor: pointer;
	}

	&:disabled {
		> div > svg {
			fill: ${({ theme }) => `${theme.palette.hexFor("primary_1_200")}`};
		}
	}
	${position}
`;
